import { Badge, Table } from 'react-bootstrap';
import { Product } from '../types/Product';
import styles from './RSCatalogProductTable.module.css';

type Props = {
  products: Product[];
  onRowClick: (index: number) => void;
};

export const RSCatalogProductTable = ({ products, onRowClick }: Props) => {
  return (
    <Table responsive hover>
      <thead className={styles.japaneseTableHead}>
        <tr>
          <th>観測対象</th>
          <th>プロダクト</th>
          <th>センサ</th>
          <th>分解能</th>
          <th>提供機関</th>
          <th>料金</th>
        </tr>
      </thead>
      <tbody>
        {products.map((p, i) => (
          <tr key={p.id} className={styles.clickable} onClick={() => onRowClick(i)}>
            <td>{p.target}</td>
            <td className={styles.multilineText}>{p.name}</td>
            <td>
              <b>{p.sensor}</b>
              <br />
              {p.sensorJa}
            </td>
            <td className={styles.multilineText}>{p.resolution}</td>
            <td>{p.provider}</td>
            <td>
              {p.fee === '無償' ? (
                <Badge bg="success">無償</Badge>
              ) : p.fee === '有償' ? (
                <Badge bg="warning" text="dark">
                  有償
                </Badge>
              ) : (
                p.fee
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
